import es from './es';
import en from './en';
import de from './de';
import pl from './pl'

export const dictionaryList = {
  es,
  en,
  de,
  pl
};

export const languageOptions = [
  { id: 'es', text: 'Spanish' },
  { id: 'en', text: 'English'},
  { id: 'de', text: 'Deutsch' },
  { id: 'pl', text: 'Polish' }
];
